<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n3">{{$t("Unloading Fuel")}}</h1>
        </v-flex>

        <v-flex xs12 class="mb-4">
          <v-layout row wrap>
          <v-btn class="ml-3 mt-2 mr-3" :loading="loading" color="primary" @click="loadUnloadingFuels"><v-icon>search</v-icon>{{$t('Search')}}</v-btn>
          <v-flex grow></v-flex>
          <v-flex shrink><v-select class="ml-2" hide-details="true" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select></v-flex>
          </v-layout>
        </v-flex>

        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        <v-flex xs12 v-else>
          <div v-if="registrations != null && registrations.length == 0" class="mt-4" style="text-align: center">{{$t("No unfinished registrations found")}}</div>
          <div v-else>
            <v-flex xs12>
              <h2 class="mb-2 mt-0">{{$t("Deliveries found")}} ({{registrations ? registrations.length : 0}}):</h2>
            </v-flex>
          <template v-for="fuelItem in registrations">
             <div :key="fuelItem.id">
              <ActiveUnloadingFuel :fuelItem="fuelItem"/>
              </div>
          </template>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <div v-if="loading"></div>
        <v-flex xs12 v-else>
          <h2 class="mb-4 mt-4">{{$t("Recent Registrations")}}</h2>
        </v-flex>

        <div v-if="loading"></div>
        <v-flex xs12 v-else>
          <div v-if="recentregistrations != null && registrations.length == 0" class="mt-4" style="text-align: center">{{$t("No recent registrations found")}}</div>
          <div v-else v-for="recentReg in recentregistrations" :key="recentReg.id">
              <RecentUnloadingFuel :recentReg="recentReg"/>
          </div>

        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import filters from '@/core/mixins/common-filters'
import * as UnloadingFuel from '@/modules/unloading-fuel/unloading-fuel'
import * as Archive from '@/core/archive'
import * as LocalStorage from '@/core/local-storage'
import ActiveUnloadingFuel from '@/modules/unloading-fuel/views/ActiveUnloadingFuel'
import RecentUnloadingFuel from '@/modules/unloading-fuel/views/RecentUnloadingFuel'
import * as Security from '@/core/security'
import _ from 'lodash' // clone

export default {
  mixins: [filters],
  name: 'unloading-fuel',
  components: { ActiveUnloadingFuel, RecentUnloadingFuel },
  data () {
    return {
      loading: false,
      registrations: null,
      recentregistrations: null,
      facilityNo: null,
      facilities: null,
      facilitiesDescription: [],
      facilityDescription: '',
      useFacilityDescription: false,
      facilityDisplay: '',
      facilitiesDisplay: [],
      returnTo: 'pre-registration-registrations'
    }
  },
  watch: {
  },
  methods: {
    loadUnloadingFuelsFromCancel () {
      this.loadUnloadingFuels()
    },
    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }
      if (this.facilityNo != null) LocalStorage.save('facilityNo', this.facilityNo)
      await this.loadUnloadingFuels()
    },
    async loadUnloadingFuels () {
      this.loading = true
      const res = await UnloadingFuel.loadRegistrations(this.facilityNo)
      // console.log('hip ', res.data)
      if (!res.failed) {
        this.registrations = res.data
      }
      const recentres = await UnloadingFuel.loadrecentRegistrations(this.facilityNo)
      if (!recentres.failed) {
        this.recentregistrations = recentres.data
      }
      this.loading = false
    }
  },
  computed: {
  },
  beforeDestroy () {
    // Unsubscribe to event listener for events from LoadVehicles(), when only ONE vehicle exist. Update all other details for this vehicle
    this.$root.$off('msgloadUnloadingFuels', this.msgloadUnloadingFuels)
  },
  async mounted () {
    this.msgloadUnloadingFuels = () => { this.loadUnloadingFuelsFromCancel() }
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    const facilitiesRes = await Archive.loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      // Let user select no facilities (= show data from all allowed facilities)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
      this.facilitiesDisplay = this.facilities
      if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
        var d = facilitiesResDescription.data
        if (!d.includes('')) d.unshift({ No: '', Description: '' })
        this.facilitiesDescription = d.map(item => {
          return {
            text: item.Description,
            value: item.Description,
            item: item
          }
        })

        this.facilitiesDisplay = this.facilitiesDescription
      }
    }

    const storedFacilityNo = '' + LocalStorage.load('facilityNo')
    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) {
      this.facilityNo = storedFacilityNo
      this.facilityDisplay = this.facilityNo
    } else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }

    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }

    await this.loadUnloadingFuels()

    this.$root.$on('msgloadUnloadingFuels', this.msgloadUnloadingFuels)
  }
}
</script>
<style>
</style>
